import { scopedTranslation } from '@frontend/utils/I18n'

const t = scopedTranslation('components.impact_dashboard.headline')

type ImpactHeadlineProps = {
  successfulCount: number
  totalCallsAttemptedCount: number
}

export function ImpactHeadline({ successfulCount, totalCallsAttemptedCount }: ImpactHeadlineProps) {
  if (totalCallsAttemptedCount === 0) return null

  const headline = successfulCount === 0
    ? t('no_connections')
    : t('connections_made', { count: successfulCount })

  return (
    <h2 className="tw:text-2xl tw:font-bold tw:text-purple-700">
      {headline}{successfulCount > 0 && ' 🎉'}
    </h2>
  )
}
